import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { ICompanyModel } from '@apps-common/types/management/company'

export const createCompany = async (model: ICompanyModel): Promise<ICompanyModel> =>
  axios.post(`/management/company/addcompany`, model).then((res) => res?.data?.data)

type Props = {
  model: ICompanyModel
}

export const useManagementCreateCompany = (notify?: boolean, onSuccess?: (data: ICompanyModel) => void) =>
  useMutation({
    mutationKey: ['createCompany'],
    mutationFn: ({ model }: Props) => createCompany(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Created company.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to create company, please try again.')
      }
    },
    throwOnError: false
  })
